// components/EmailUpdatesBanner.jsx
import { useState, useEffect } from 'react';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db, auth } from '../../firebase';

export default function EmailUpdatesBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const checkPreference = async () => {
      if (localStorage.getItem('boply-updates-responded')) return;
      if (!auth.currentUser) return;

      // Track visits
      let visits = parseInt(localStorage.getItem('boply-visits') || '0');
      visits++;
      localStorage.setItem('boply-visits', visits.toString());

      if (visits < 2) return;

      const userRef = doc(db, 'users', auth.currentUser.uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const data = userSnap.data();
        if (data.wantsUpdates === undefined) {
          setShow(true);
        }
      }
    };

    checkPreference();
  }, []);

  const handleResponse = async (wantsUpdates) => {
    if (!auth.currentUser) return;

    localStorage.setItem('boply-updates-responded', 'true');

    const userRef = doc(db, 'users', auth.currentUser.uid);
    await updateDoc(userRef, {
      wantsUpdates: wantsUpdates,
      updatesRespondedAt: new Date()
    });

    setShow(false);
  };

  if (!show) return null;

  return (
  <div className="fixed bottom-16 md:bottom-0 left-0 right-0 bg-purple-600 text-white px-4 py-3 z-50">
    <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
      
      <p className="text-sm text-center sm:text-left">
        📬 Join the BOPly mailing list for feature updates, tips, and tutorials
      </p>
      
      <div className="flex gap-2">
        <button
          onClick={() => handleResponse(true)}
          className="px-4 py-1.5 bg-white text-purple-600 font-semibold text-sm rounded-lg hover:bg-gray-100 transition"
        >
          Subscribe
        </button>
        <button
          onClick={() => handleResponse(false)}
          className="px-4 py-1.5 bg-purple-700 text-white font-semibold text-sm rounded-lg hover:bg-purple-800 transition"
        >
          No thanks
        </button>
      </div>
      
    </div>
  </div>
);
}